module.exports = __webpack_public_path__ + "e61f3495a7ecd3d571a4c9a98797e955.woff";